import React from 'react';
import './footer.css';

const Footer = () => {
  return (
    <section className="" id="footer">
      <h5>Bye Bye</h5>
      <h2>See you!</h2>
    </section>
  )
};

export default Footer;